module.exports = __webpack_public_path__ + "img/chips100000.38abeb37.webp";